
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
    <div>
        <h3>МАК СТРОЙ</h3>
        <p> МАК СТРОЙ
         Профессиональное асфальтирование дорог, дворов и парковок.
         Работаем по всей Москву, гарантируя качество,
         надежность и соблюдение сроков выполнения работ.</p>
        </div>
       
        <div>
          <h3>Контакты</h3>
        <a href="+7-964-514-46-40" >📞+7-964-514-46-40</a>
        <a href="+7-925-867-91-52" >📞+7-925-867-91-52</a>

              <br />   📍 Москва , Московская область
         <br />📧 makich.avetisyan88@mail.ru
        <br /> 🕒 Пн–Вс: 08:00–21:00
        </div>

        <div>
          <h3>Услуги</h3>
          • Асфальтирование дорог
          • Асфальтирование дворов
          • Асфальтирование парковок
          • Ямочный ремонт
          • Укладка бордюров
          • Подготовка основания
        </div>
      </div>

      <div className="copyright">
        ГОТОВЫ НАЧАТЬ ПРОЕКТ?
       Свяжитесь с нами для бесплатного расчета стоимости.

       © 2026 МАК СТРОЙ. Все права защищены.
      </div>
    </footer>
  );
}

export default Footer;